import React, { Component } from 'react';
import selos from '../images/selos.png';
import selos2 from '../images/selos2.png';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import Swal from 'sweetalert2';



class login extends Component {

    constructor(props){
        super(props);
        this.state = {
            opacity1: false,
            number: '',
            formattedValue: ''
        }
    }

    executeFunction = (event) => {
        event.preventDefault();
        this.setState({opacity1: true}); 

        axios.post(`https://www.pagtel.com.br/AlgarCasca360/auth/v1/validatePhone`, {
            Network:"Algar",
            MSISDN: "55"+this.state.number,
            Version: "0.1",
            UniqueID: "xxxxx",
            OS: "Navegador",
            SystemVersion:"0.1",
            Model: "PC",
            Source: "site"
        })
        .then(res => {
            if(res.data.code === "00"){
                this.props.changeConfirmation("second",true,this.state.number, this.state.formattedValue, res.data.accessToken);
            }
            else if(res.data.code === "04"){
                this.props.changeConfirmation("first",true,this.state.number, this.state.formattedValue, res.data.accessToken);
            }
            else {
                Swal.fire(
                'Erro!',
                res.data.msg,
                'error'
                )
                this.setState({opacity1: false}); 
            }
        })
        .catch(res => {
            Swal.fire(
                'Erro!',
                "Não foi possível conectar com o servidor!",
                'error'
            )
        })

    }

  render() {
    const opacity1 = this.state.opacity1 ? 'opacity' : '';

    return (
        <div className="content-left">
            <h3>RECARGA ONLINE</h3>
            <p>QUAL NÚMERO VOCÊ DESEJA
            RECARREGAR?</p>
            <form onSubmit={this.executeFunction}>
                <div className="content-left--input">
                    <div className="content-left--input-cell">

                    <NumberFormat className="number" placeholder="Digite seu número"  
                    onValueChange={(values) => {
                        const {formattedValue, value} = values;
                        this.setState({number: value})
                        this.setState({formattedValue: formattedValue})
                        console.log(this.state.number.toString().length);
                    }} 
                    value={this.state.number} format={this.state.number.toString().length > 10 ?  "(##) #####-####" : "(##) ####-#####"} />
                        <i className="icon-cel"></i>
                    </div>
                    <div onClick={this.executeFunction} className={`content-left--input-btn ${opacity1}`}>
                        RECARREGAR
                    </div>
                </div>
            </form>
            <p className="second-p">APROVEITE ESTA FACILIDADE E RECARREGUE
            TAMBÉM O CELULAR DE PARENTES E AMIGOS!</p>
            <div className="content-left-selos">
            <img src={selos} alt="selos"/>
            </div>
            <div className="content-left-selos">
            <img src={selos2} alt="selos"/>
            </div>
        </div>
        
    )
  }

  
}

export default login; // Don’t forget to use export default!